<!-- 平台管理 -->
<template>
    <div>
        <div class="header">
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.keywords"
                placeholder="请输入公司名称或账号"
            ></Input>
            <Select
                class="w200 mr24 mb24"
                v-model="storePrams.status"
                clearable
                filterable
            >
                <Option
                    v-for="item in statusList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                >
            </Select>
            <Button
                class="theme-bc mb24"
                icon="ios-search"
                type="warning"
                @click="goSearch"
                >确认搜索</Button
            >
        </div>
        <div class="content">
            <div>
                <Button
                    class="theme-bc mb24"
                    icon="md-add-circle"
                    type="warning"
                    @click="gomodal"
                    >新增账号</Button
                >
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ row }" slot="company_name">
                        <div>
                            {{ row.company ? row.company.company_name : "" }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="app">
                        <Button @click="goApp(row)">设置</Button>
                    </template>
                    <template slot-scope="{ row }" slot="mould">
                        <Button @click="goMould(row)">设置</Button>
                    </template>
                    <template slot-scope="{ row }" slot="end_date">
                        <div class="cursor-pointer" @click="goEndDate(row)">
                            {{ row.version ? row.version.end_date : "" }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="last_log">
                        <div v-if="row.last_log">
                            {{ row.last_log.created_at }} |
                            {{ row.last_log.terminal_text }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div>
                            {{
                                row.status == 1
                                    ? "正常"
                                    : row.status == 3
                                    ? "已到期"
                                    : "禁用"
                            }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button
                                type="primary"
                                ghost
                                label="small"
                                @click="gomodal(row)"
                                >编辑</Button
                            >
                            <Button
                                v-if="row.status != 1"
                                type="primary"
                                ghost
                                label="small"
                                @click="goDisable(row)"
                                >启用</Button
                            >
                            <Button
                                v-if="row.status == 1"
                                type="error"
                                ghost
                                label="small"
                                @click="goDisable(row)"
                                >禁用</Button
                            >
                            <Button
                                v-if="row.status != 0"
                                type="primary"
                                ghost
                                label="small"
                                @click="goRenew(1, row)"
                                >续费</Button
                            >
                            <Button
                                type="success"
                                ghost
                                label="small"
                                @click="goToken(row)"
                                >进入系统</Button
                            >
                            <Button
                                v-if="row.status == 0"
                                type="error"
                                ghost
                                label="small"
                                @click="goDel(row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="text-align-right mt24">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="500"
            :mask-closable="false"
        >
            <Form :model="formItem" label-position="right" :label-width="130">
                <FormItem label="手机号：">
                    <Input
                        class="w200"
                        type="number"
                        v-model="formItem.phone"
                        placeholder="请输入手机号"
                    ></Input>
                </FormItem>
                <FormItem label="账号：">
                    <Input
                        class="w200"
                        type="text"
                        v-model="formItem.user"
                        placeholder="请输入账号"
                    ></Input>
                </FormItem>
                <FormItem label="密码：">
                    <Input
                        class="w200"
                        type="text"
                        v-model="formItem.password"
                        placeholder="请输入密码"
                    ></Input>
                </FormItem>
                <FormItem v-if="modalTitle == '新增账号'" label="选择版本: ">
                    <Select
                        class="w200"
                        v-model="formItem.version_id"
                        clearable
                        filterable
                    >
                        <Option
                            v-for="item in versionList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.title }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="授权域名：">
                    <Input
                        class="w200"
                        type="text"
                        v-model="formItem.auth_domain"
                        placeholder="请输入不含www 的一级域名"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal"
                    >确认</Button
                >
            </div>
        </Modal>
        <!-- 续费 -->
        <Modal
            v-model="renewModals"
            :title="renewTitle"
            width="500"
            :mask-closable="false"
        >
            <Form :model="formRenew" label-position="right" :label-width="100">
                <FormItem label="选择版本: ">
                    <Select
                        class="w200"
                        v-model="formRenew.version_id"
                        clearable
                        filterable
                    >
                        <Option
                            v-for="item in versionList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.title }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="开始时间: ">
                    <DatePicker
                        class="w200"
                        :value="formRenew.start_date"
                        type="date"
                        placeholder="请选择开始时间"
                        @on-change="changeStartDate"
                    ></DatePicker>
                </FormItem>
                <FormItem label="截止时间: ">
                    <DatePicker
                        class="w200"
                        :value="formRenew.end_date"
                        type="date"
                        placeholder="请选择截止时间"
                        @on-change="changeEndDate"
                    ></DatePicker>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelRenewModal">取消</Button>
                <Button
                    class="theme-bc"
                    type="warning"
                    @click="submitRenewModal"
                    >确认</Button
                >
            </div>
        </Modal>
        <!-- 应用权限设置 -->
        <Modal
            v-model="appModals"
            title="应用权限设置"
            width="500"
            :mask-closable="false"
        >
            <Form :model="formApp" label-position="right" :label-width="170">
                <FormItem
                    v-for="(item, index) in formApp.dataList"
                    :key="index"
                    :label="item.title + '：'"
                >
                    <i-switch
                        v-model="item.status"
                        true-color="#FF761D"
                        @on-change="changeStatus(item, $event)"
                    ></i-switch>
                </FormItem>
            </Form>
            <div slot="footer"></div>
        </Modal>
        <!-- 模板权限 -->
        <Modal v-model="mouldModals" width="800">
            <div>
                <Menu
                    mode="horizontal"
                    :active-name="storePramsMould.type"
                    @on-select="selectMould"
                >
                    <MenuItem name="1">产品模板</MenuItem>
                    <MenuItem name="2">查询模板</MenuItem>
                </Menu>
                <Table
                    class="mt24"
                    :columns="columnsMould"
                    :data="dataMould"
                    border
                >
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <i-switch
                            v-model="row.status"
                            true-color="#FF761D"
                            @on-change="changeMouldOperate(row, $event)"
                        ></i-switch>
                    </template>
                </Table>
                <div class="text-align-right mt24">
                    <Page
                        :current="storePramsMould.page"
                        :page-size="storePramsMould.limit"
                        :total="totalMould"
                        show-total
                        @on-change="changeMould"
                    />
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 账户版本列表 -->
        <Modal
            v-model="endDateModals"
            title="账户版本列表"
            width="1000"
            :mask-closable="false"
        >
            <div>
                <Button
                    class="theme-bc mb24"
                    icon="md-add-circle"
                    type="warning"
                    @click="goRenew(2)"
                    >续费</Button
                >
                <Table
                    :columns="columnsTableEndDate"
                    :data="dataTableEndDate"
                    border
                >
                    <template slot-scope="{ row, index }" slot="id">
                        <!-- 过期版本 -->
                        <div v-if="row.status == 0" class="end-date-none">
                            {{ index + 1 }}
                        </div>
                        <!-- 当前版本 -->
                        <div
                            v-else-if="row.status == 1"
                            class="end-date-active"
                        >
                            {{ index + 1 }}
                        </div>
                        <div v-else>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="name">
                        <div v-if="row.status == 0" class="end-date-none">
                            {{ row.name }}
                        </div>
                        <div
                            v-else-if="row.status == 1"
                            class="end-date-active"
                        >
                            {{ row.name }}
                        </div>
                        <div v-else>{{ row.name }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="start_date">
                        <div v-if="row.status == 0" class="end-date-none">
                            {{ row.start_date }}
                        </div>
                        <div
                            v-else-if="row.status == 1"
                            class="end-date-active"
                        >
                            {{ row.start_date }}
                        </div>
                        <div v-else>{{ row.start_date }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="end_date">
                        <div v-if="row.status == 0" class="end-date-none">
                            {{ row.end_date }}
                        </div>
                        <div
                            v-else-if="row.status == 1"
                            class="end-date-active"
                        >
                            {{ row.end_date }}
                        </div>
                        <div v-else>{{ row.end_date }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="qrcode_nums">
                        <div v-if="row.status == 0" class="end-date-none">
                            {{ row.qrcode_nums }}
                        </div>
                        <div
                            v-else-if="row.status == 1"
                            class="end-date-active"
                        >
                            {{ row.qrcode_nums }}
                        </div>
                        <div v-else>{{ row.qrcode_nums }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="remaining_nums">
                        <div v-if="row.status == 0" class="end-date-none">
                            {{ row.remaining_nums }}
                        </div>
                        <div
                            v-else-if="row.status == 1"
                            class="end-date-active"
                        >
                            {{ row.remaining_nums }}
                        </div>
                        <div v-else>{{ row.remaining_nums }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sb">
                            <Button
                                type="primary"
                                ghost
                                label="small"
                                @click="goRenew(3, row)"
                                >编辑</Button
                            >
                            <Button
                                type="success"
                                ghost
                                label="small"
                                @click="goAddNums(row)"
                                >增加码量</Button
                            >
                            <Button
                                v-if="row.status == 2"
                                type="error"
                                ghost
                                label="small"
                                @click="goDelEndDate(row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="text-align-right mt24">
                    <Page
                        :current="storePramsEndDate.page"
                        :page-size="storePramsEndDate.limit"
                        :total="totalEndDate"
                        show-total
                        @on-change="pageChangeEndDate"
                    />
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 增加码量 -->
        <Modal
            v-model="addNumsModals"
            title="增加码量"
            width="500"
            :mask-closable="false"
        >
            <Form
                :model="formAddNums"
                label-position="right"
                :label-width="130"
            >
                <FormItem label="增加可生成码量：">
                    <Input
                        class="w200"
                        type="text"
                        v-model="formAddNums.nums"
                        placeholder="请输入增加可生成码量"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelAddNumsModal">取消</Button>
                <Button
                    class="theme-bc"
                    type="warning"
                    @click="submitAddNumsModal"
                    >确认</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    plat_account_list,
    plat_account_save,
    plat_account_delete,
    plat_account_disable,
    plat_account_template_index,
    plat_account_template_change,
    plat_account_app_index,
    plat_account_app_change,
    plat_account_token,
    version_select,
    account_version,
    account_version_delete,
    account_version_renew,
    account_version_edit,
    version_add_nums,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 30,
                keywords: "",
                status: -1,
            },
            total: 0,
            statusList: [
                { id: -1, name: "全部" },
                { id: 0, name: "禁用" },
                { id: 1, name: "正常" },
                { id: 3, name: "已到期" },
            ],
            columnsTable: [
                { title: "账号ID", key: "id", align: "center", width: "100" },
                {
                    title: "账号名称",
                    key: "user",
                    align: "center",
                    width: "200",
                },
                {
                    title: "公司名称",
                    slot: "company_name",
                    align: "center",
                    width: "200",
                },
                {
                    title: "手机号",
                    key: "phone",
                    align: "center",
                    width: "130px",
                },
                {
                    title: "应用权限",
                    slot: "app",
                    align: "center",
                    width: "100",
                },
                {
                    title: "模板权限",
                    slot: "mould",
                    align: "center",
                    width: "100",
                },
                {
                    title: "到期时间",
                    slot: "end_date",
                    align: "center",
                    width: "170px",
                },
                {
                    title: "最后登录时间",
                    slot: "last_log",
                    align: "center",
                    width: "200px",
                },
                {
                    title: "创建时间",
                    key: "created_at",
                    align: "center",
                    width: "170px",
                },
                {
                    title: "状态",
                    slot: "status",
                    align: "center",
                    width: "100",
                },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    fixed: "right",
                    width: "400px",
                },
            ],
            dataTable: [],
            modals: false,
            modalTitle: "",
            formItem: {
                user: "",
                phone: "",
                password: "",
                version_id: 1,
                auth_domain: "",
                id: "",
            },
            renewModals: false,
            renewTitle: "",
            formRenew: {
                admin_id: "",
                id: "",
                version_id: 1,
                start_date: "",
                end_date: "",
            },
            appModals: false,
            formApp: {
                id: "",
                dataList: [],
            },
            mouldModals: false,
            storePramsMould: {
                page: 1,
                limit: 10,
                id: "",
                type: "1",
            },
            totalMould: 0,
            columnsMould: [
                { type: "index", width: 60, align: "center" },
                { title: "模板名称", key: "title", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataMould: [],
            versionList: [],
            endDateModals: false,
            storePramsEndDate: {
                page: 1,
                limit: 30,
                id: "",
            },
            totalEndDate: 0,
            columnsTableEndDate: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "版本名称", slot: "name", align: "center" },
                { title: "开始时间", slot: "start_date", align: "center" },
                { title: "截止时间", slot: "end_date", align: "center" },
                { title: "生码量", slot: "qrcode_nums", align: "center" },
                {
                    title: "剩余生码量",
                    slot: "remaining_nums",
                    align: "center",
                },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "300px",
                },
            ],
            dataTableEndDate: [],
            renew_value: 0,
            addNumsModals: false,
            formAddNums: {
                id: "",
                admin_id: "",
                nums: "",
            },
        };
    },
    mounted() {
        this.getList();
        this.getVersionSelect();
    },
    methods: {
        getVersionSelect() {
            version_select().then((res) => {
                this.versionList = res.data;
            });
        },
        getList() {
            plat_account_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        gomodal(row) {
            if (row.id) {
                this.modalTitle = "编辑账号";
                this.formItem.user = row.user;
                this.formItem.phone = row.phone;
                this.formItem.auth_domain = row.info
                    ? row.info.auth_domain
                    : "";
                this.formItem.id = row.id;
                this.formItem.password = "";
            } else {
                this.modalTitle = "新增账号";
                this.formItem.user = "";
                this.formItem.phone = "";
                this.formItem.password = "";
                this.formItem.version_id = 1;
                this.formItem.auth_domain = "";
                this.formItem.id = "";
            }
            this.modals = true;
        },
        // 确定
        submitModal() {
            plat_account_save(this.formItem)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelModal() {
            this.modals = false;
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    plat_account_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        goDisable(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "是否确认修改" + row.user + "授权！",
                onOk: () => {
                    plat_account_disable({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        goRenew(index, row) {
            this.renew_value = index;
            if (this.renew_value == 1 || this.renew_value == 2) {
                // 获取当前时间
                const startDate = new Date();
                this.formRenew.start_date = this.formatDate(startDate);
                const endDate = new Date(startDate);
                endDate.setDate(startDate.getDate() + 365);
                this.formRenew.end_date = this.formatDate(endDate);
                this.renewTitle = "续费";
                this.formRenew.id = "";
                if (this.renew_value == 1) {
                    this.formRenew.admin_id = row.id;
                    this.formRenew.version_id = row.version
                        ? row.version.version_id
                        : 1;
                } else if (this.renew_value == 2) {
                    this.formRenew.admin_id = this.storePramsEndDate.id;
                    this.formRenew.version_id = 1;
                }
            } else if (this.renew_value == 3) {
                this.formRenew.admin_id = this.storePramsEndDate.id;
                this.formRenew.id = row.id;
                this.formRenew.start_date = row.start_date;
                this.formRenew.end_date = row.end_date;
                this.formRenew.version_id = row.version_id;
                this.renewTitle = "编辑账户版本";
            }
            this.renewModals = true;
        },
        cancelRenewModal() {
            this.renewModals = false;
        },
        submitRenewModal() {
            if (this.renew_value == 1 || this.renew_value == 2) {
                account_version_renew(this.formRenew)
                    .then((res) => {
                        if (this.renew_value == 2) {
                            this.getEndDateList();
                        }
                        this.getList();
                        this.renewModals = false;
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            } else if (this.renew_value == 3) {
                account_version_edit(this.formRenew)
                    .then((res) => {
                        this.getEndDateList();
                        this.getList();
                        this.renewModals = false;
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            }
        },
        goAddNums(row) {
            this.formAddNums.id = row.id;
            this.formAddNums.nums = "";
            this.addNumsModals = true;
        },
        cancelAddNumsModal() {
            this.addNumsModals = false;
        },
        submitAddNumsModal() {
            version_add_nums(this.formAddNums)
                .then((res) => {
                    this.getEndDateList();
                    this.addNumsModals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
        goEndDate(row) {
            this.formAddNums.admin_id = row.id;
            this.storePramsEndDate.id = row.id;
            this.getEndDateList();
            this.endDateModals = true;
        },
        getEndDateList() {
            account_version(this.storePramsEndDate).then((res) => {
                this.dataTableEndDate = res.data.data;
                this.totalEndDate = res.data.total;
            });
        },
        pageChangeEndDate(index) {
            this.storePramsEndDate.page = index;
            this.getEndDateList();
        },
        goDelEndDate(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    var data = {
                        admin_id: this.storePramsEndDate.id,
                        id: row.id,
                    };
                    account_version_delete(data)
                        .then((res) => {
                            this.getEndDateList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        // 应用权限
        goApp(row) {
            this.formApp.id = row.id;
            this.getPlatAccountAppIndex();
            setTimeout(() => {
                this.appModals = true;
            }, 500);
        },
        changeStatus(item) {
            let data = {
                id: this.formApp.id,
                app_id: item.id,
            };
            this.$Modal.confirm({
                title: "提示",
                content: "确认修改账户组件权限吗？",
                onOk: () => {
                    plat_account_app_change(data)
                        .then((res) => {
                            this.getPlatAccountAppIndex();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {
                    this.getPlatAccountAppIndex();
                },
            });
        },
        getPlatAccountAppIndex() {
            plat_account_app_index({ id: this.formApp.id }).then((res) => {
                let new_data = res.data.map((item) => ({
                    id: item.id,
                    title: item.title,
                    status: !!item.permission,
                }));
                this.formApp.dataList = new_data;
            });
        },
        // 模板权限
        goMould(row) {
            this.storePramsMould.id = row.id;
            this.storePramsMould.type = "1";
            this.getPlatAccountTemplateIndex();
            setTimeout(() => {
                this.mouldModals = true;
            }, 500);
        },
        selectMould(name) {
            this.storePramsMould.page = 1;
            this.storePramsMould.type = name;
            this.getPlatAccountTemplateIndex();
        },
        changeMould(index) {
            this.storePramsMould.page = index;
            this.getPlatAccountTemplateIndex();
        },
        // 云模板列表
        getPlatAccountTemplateIndex() {
            plat_account_template_index(this.storePramsMould).then((res) => {
                this.totalMould = res.data.total;
                let new_data = res.data.data.map((item) => ({
                    id: item.id,
                    title: item.title,
                    status: !!item.permission,
                }));
                this.dataMould = new_data;
            });
        },
        changeMouldOperate(row, e) {
            let data = {
                id: this.storePramsMould.id,
                cloud_id: row.id,
            };
            this.$Modal.confirm({
                title: "修改提示",
                content: "确认修改模板权限吗？",
                onOk: () => {
                    plat_account_template_change(data)
                        .then((res) => {
                            this.getPlatAccountTemplateIndex();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {
                    this.getPlatAccountTemplateIndex();
                },
            });
        },
        goToken(row) {
            plat_account_token({ id: row.id })
                .then((res) => {
                    let currentUrl = window.location.href.split("#")[0];
                    let url = new URL(currentUrl);
                    url.pathname = "/";
                    let baseUrl = url.href;
                    let urls = baseUrl + "store/#/?token=" + res.data.token;
                    window.open(urls, "_blank");
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        changeStartDate(e) {
            if (e) {
                this.formRenew.start_date = e;
            } else {
                this.formRenew.start_date = "";
            }
        },
        changeEndDate(e) {
            if (e) {
                this.formRenew.end_date = e;
            } else {
                this.formRenew.end_date = "";
            }
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.cursor-pointer {
    cursor: pointer;
}
.end-date-none {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #808080;
}
.end-date-active {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ff761d;
}
.text-align-right {
    text-align: right;
}
.flex-sa {
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.flex-sb {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
/* 模板权限 */
::v-deep .ivu-menu.ivu-menu-light.ivu-menu-horizontal {
    display: flex;
    align-items: center;
    justify-content: space-around;
}
::v-deep .ivu-menu-item {
    font-size: 16px;
    font-weight: 400;
}
::v-deep .ivu-menu-item:hover {
    font-size: 16px;
    font-weight: 400;
    color: #ff761d !important;
    border-bottom: 2px solid #ff761d !important;
}
::v-deep .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    font-size: 16px;
    font-weight: 400;
    color: #ff761d;
    border-bottom: 2px solid #ff761d !important;
}
</style>